export default "__VITE_ASSET__edRQhvzN__"